/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import CouponDetail from "../../components/Coupon/CouponDetail";
import GenerateCoupon from "../../components/Coupon/GenerateCoupon";
import { discountType } from "../../utils/constants";
import TopBar from "../../components/TopBar";
import { createCoupon, getCoupon, updateCoupon } from "../../api/couponsApi";

import styles from './coupon.module.css'

const AddCoupon = () => {

    const navigate = useNavigate();
    const { couponId } = useParams()
    const types = discountType;
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const formattedTomorrow = tomorrow.toISOString().split("T")[0];

    const [couponData, setCouponData] = useState({
        coupon: "",
        discountType: 'PERCENTAGE_DISCOUNT',
        couponAmount: '',
        usagePerCoupon: '',
        usagePerUser: '',
        couponExpiryDate: !couponId && formattedTomorrow
    })

    const [activeTab, setActiveTab] = useState("general");
    const [isLoading, setIsLoading] = useState(false)

    const [error, setError] = useState({
        coupon: '',
        discountType: '',
        couponAmount: '',
        usagePerCoupon: '',
        usagePerUser: '',
        couponExpiryDate: ''
    })

    const fetchCoupon = async () => {
        try {
            const response = await getCoupon(couponId)
            if (response?.success) {
                setCouponData({
                    ...response?.data,
                    coupon: response?.data?.couponCode,
                    discountType: response?.data?.discountType,
                    couponExpiryDate: response?.data?.couponExpiryDate
                })
            }
        } catch (error) {
            console.log({ error })
        }
    }

    useEffect(() => {
        if (couponId && couponId !== undefined && couponId !== '') {
            fetchCoupon()
        }
    }, [couponId])

    const validate = () => {
        let newErrors = {};

        const couponRegex = /^[A-Z0-9]+$/;

        if (!couponData?.coupon || couponData?.coupon.trim() === '') {
            newErrors.coupon = "Coupon code is required";
        } else if (!couponRegex.test(couponData.coupon)) {
            newErrors.coupon = "Coupon code must contain only capital letters (A–Z) and numbers";
        }
        if (!couponData?.discountType) newErrors.discountType = "Select discount type";
        if (!couponData?.couponAmount || parseFloat(couponData?.couponAmount) <= 0) newErrors.couponAmount = "Enter a valid coupon amount greater than 0";
        if (!couponData?.couponExpiryDate) newErrors.couponExpiryDate = "Select expiry date";
        else {
            const selectedDate = new Date(couponData?.couponExpiryDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (selectedDate <= today) newErrors.couponExpiryDate = "Expiry date must be in the future";
        }

        setError(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validate()) return;

        try {
            setIsLoading(true)
            const payload = {
                couponCode: couponData?.coupon,
                description: couponData?.description,
                discountType: couponData?.discountType,
                couponAmount: parseFloat(couponData?.couponAmount),
                couponExpiryDate: couponData?.couponExpiryDate,
            };

            if (couponId) {
                await updateCoupon(couponId, payload);
            } else {
                const response = await createCoupon(payload);
                if (response?.success) {
                    const responseUpdate = await updateCoupon(response?.data?.couponId, payload);
                    if (responseUpdate?.success) {
                        navigate(`/coupon/${response?.data?.couponId}`);
                    }
                }
            }
            setIsLoading(false)
        } catch (error) {
            console.log('Error creating coupon:', error);
            setIsLoading(false)
        }
    };


    return (
        <>
            <div>
                <TopBar />
                <div className={styles.addCouponContainer}>
                    <GenerateCoupon
                        couponData={couponData}
                        setCouponData={setCouponData}
                        setError={setError}
                        error={error}
                    />
                    <CouponDetail
                        couponData={couponData}
                        setCouponData={setCouponData}
                        types={types}
                        setError={setError}
                        error={error}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />
                    <div className={`save-btn-group ${styles.saveButton}`}>
                        <button onClick={handleSave} className='save-btn'>
                            {
                                isLoading ? <div className={`ringLoader loaderContinue`}></div> : 'Save'
                            }
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AddCoupon;